import { OpenAIConfig } from '../types/openai';

// Utility to verify that a potential key value is usable.  Vite sometimes
// injects the string "false" for unset env variables, so we treat that the same
// as an empty value.
function isValidKey(value: string | undefined): value is string {
  return Boolean(value && value !== 'false');
}

// Default to an empty string so the type is always `string`.  This prevents
// TypeScript errors during builds where the environment variable might not be
// set at compile time.
let openAiApiKey = '';

// Vite exposes variables prefixed with `VITE_` to the client.  This will be the
// normal path during development and when building the frontend.
if (
  typeof import.meta !== 'undefined' &&
  import.meta.env &&
  isValidKey(import.meta.env.VITE_OPENAI_API_KEY)
) {
  openAiApiKey = import.meta.env.VITE_OPENAI_API_KEY;
}

// Fallback for runtime environments where a global variable is provided.  This
// allows the API key to be injected when the container starts rather than at
// build time.
if (
  !openAiApiKey &&
  typeof globalThis !== 'undefined' &&
  isValidKey((globalThis as any).OPENAI_API_KEY)
) {
  openAiApiKey = (globalThis as any).OPENAI_API_KEY;
}

// Final fallback for Node environments where `import.meta.env` is unavailable.
if (!openAiApiKey && typeof process !== 'undefined') {
  const envKey = process.env.OPENAI_API_KEY;
  if (isValidKey(envKey)) {
    openAiApiKey = envKey;
  }
}

export const OPENAI_CONFIG: OpenAIConfig = {
  apiKey: openAiApiKey,
  model: 'gpt-4o',
  temperature: 0.2,
  maxTokens: 500,
  vectorStoreId: 'vs_67c09dbb51d481919cb976014c8bb8dc',
  assistantId: 'asst_zj3XuxrxWgoqIAj0Q7n9mg6H'
};
